import { useTrackingPage } from "@/mixins/tracking/all-pages";

export const pageInfosEtServicesPageContenuProps = () => ({
  cmsReponse: {
    type: Object,
    required: false
  },
  context: {
    type: String,
    required: false,
    default: 'cms'
  }
})

export const usePageInfosEtServicesPageContenu = (props) => {

  const { trackPage } = useTrackingPage();

  const title = computed(() => {
    return props.cmsReponse && props.cmsReponse.meta && props.cmsReponse.meta.head ? props.cmsReponse.meta.head.title : ''
  })

  const updated = () => {
    trackPage(trackingCodes.PAGETYPE.cmsPage);
  }

  return {
    title,
    updated,
    trackPage
  }
}